import { createAction } from 'redux-actions';

export const toggleSidebarNav = createAction('TOGGLE_INVENTORY_SIDEBAR_NAV');

export const toggleDropdownNavItem = createAction(
  'TOGGLE_INVENTORY_DROPDOWN_NAV_ITEM'
);

export const resetDropdownNavItems = createAction(
  'RESET_INVENTORY_DROPDOWN_NAV_ITEMS'
);

export const clearItemsTemplateDownloadUrl = createAction(
  'CLEAR_INVENTORY_ITEMS_TEMPLATE_DOWNLOAD_URL'
);
